export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40a6fe76f08b3189d3ce117d6064ac6762e9b913fe&name=revalidateCommunity!'